import React from 'react';
import { Tooltip, Icon } from 'antd';
import { FaThumbsDown } from 'react-icons/fa';
import { Card, Title, Value, Percentage, Details, DetailItem, InfoIcon } from './styles';

var SummaryCard = function(props) {
  var item = props.item;
  var onClick = props.onClick;

  var handleClick = function() {
    if (onClick && item.done > 0) {
      onClick(item);
    }
  };

  return (
    <Card
      onClick={handleClick}
      clickable={item.done > 0}
      style={{ cursor: item.done > 0 ? 'pointer' : 'default' }}
    >
      <Tooltip title={item.tooltip} placement="bottom">
        <InfoIcon>
          <Icon type="info-circle" />
        </InfoIcon>
      </Tooltip>
      <Percentage>{item.percentage}</Percentage>
      <Title color={item.color}>
        {item.icon}
        {item.title}
      </Title>
      <Value>{item.done}</Value>
      {item.title !== "Leads" && item.title !== "Inicio" && (
        <Details>
          <DetailItem color="#e4405f">
            <FaThumbsDown />
            {item.undone}
          </DetailItem>
        </Details>
      )}
    </Card>
  );
};

export default React.memo(SummaryCard);
